import { IListApiResponse } from 'api/types'
import channelApi from '../../api/channelApi'
import {
  AppChannelListResponse,
  AppChannelSaveRequest,
  FacebookBusinessResponse,
  TokenRequest,
  IListApiRequestWithChannel,
  Channel
} from './types'
import { getPaginationQueryParams } from './utils'

const channelOnboardingApiSlice = channelApi.injectEndpoints({
  endpoints: (build) => ({
    facebookExchageToken: build.mutation<
      void,
      { TokenRequestDTO: TokenRequest }
    >({
      query: ({ TokenRequestDTO }) => {
        return {
          url: `/whatsapp/exchange_token`,
          method: 'POST',
          data: TokenRequestDTO
        }
      },
      invalidatesTags: ['channelList']
    }),
    createAppChannel: build.mutation<
      AppChannelListResponse,
      AppChannelSaveRequest
    >({
      query: (appChannelData) => ({
        url: `/channelOnboardingExtended`,
        method: 'POST',
        data: appChannelData
      }),
      invalidatesTags: ['channelList']
    }),
    getChannelOnboardings: build.query<
      IListApiResponse<FacebookBusinessResponse>,
      IListApiRequestWithChannel<FacebookBusinessResponse>
    >({
      query: (request) => {
        const { selectedChannel } = request
        const params = getPaginationQueryParams(request)
        if (selectedChannel === 'AgroBeet-App') {
          params.channel = Channel.INAPP
        } else if (selectedChannel === 'WhatsApp') {
          params.channel = Channel.WHATSAPP
        } else if (selectedChannel === 'SMS') {
          params.channel = Channel.SMS
        }

        return {
          url: `/channelOnboardingExtended`,
          method: 'GET',
          params
        }
      },
      providesTags: ['channelList']
    }),
    deleteChannelOnboarding: build.mutation<
      void,
      { whatsAppChannelId: string }
    >({
      query: ({ whatsAppChannelId: id }) => ({
        url: `/channel-onboardings/${id}`,
        method: 'DELETE'
      }),
      invalidatesTags: ['channelList']
    })
  })
})

export const {
  useDeleteChannelOnboardingMutation,
  useFacebookExchageTokenMutation,
  useGetChannelOnboardingsQuery,
  useCreateAppChannelMutation
} = channelOnboardingApiSlice

export default channelOnboardingApiSlice
